export const consts = {
    CampaignFilterStorageKey: "campaignFilterStorageKey",
    PublisherIdsFilterStorageKey: "publisherIdsFilterStorageKey",
    MediationFilterStorageKey: "mediationFilterStorageKey",
    ProviderIdsFilterStorageKey: "providerIdsFilterStorageKey",
    StartDateGreaterThanEndDateText: "Start date is greater than end date!",
    BrandInfoNotSelectedText: "Must select brand and logo!",

    //used in the campaign and publisher parameter forms
    DefaultTotalAllocatedViews: 2000000000,
    DefaultTotalAllocatedViewsPerDay: 2000000000,
    DefaultTotalAllocatedViewsPerUser: 2000000000,
    DefaultMinAge: 0,
    DefaultMaxAge: 100,
    DefaultValue: 0,
    DefaultFloorPrice: 0,
    DefaultPublisherCpe: 0,
    DefaultPublisherTotalAllocatedViews: 2000000000,
    DefaultPublisherTotalAllocatedViewsPerDay: 2000000000,
    DefaultPublisherTotalAllocatedViewsPerUser: 2000000000,    

    //for determining the providers for grid campaigns in order to generate ad trailers
    UnrulyGridProvider: 9
}


// WEBPACK FOOTER //
// ./src/app/shared/consts.ts